// @vue/component
export default {
  name: 'ShPopconfirm',

  props: {
    placement: {
      type: String,
      default: 'top',
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: 'fa-question-circle',
    },
    iconColor: {
      type: String,
      default: '#F6A821',
    },
    confirmText: {
      type: String,
      default: 'Yes',
    },
    cancelText: {
      type: String,
      default: 'No',
    },
    shouldShow: {
      type: Boolean,
      default: true,
    },
    defaultEvent: {
      type: String,
      default: 'confirm',
    },
  },

  data() {
    return {
      isVisible: false,
    };
  },

  methods: {
    handleCancel() {
      this.isVisible = false;
      this.$emit('cancel');
    },
    handleConfirm() {
      this.isVisible = false;
      this.$emit('confirm');
    },
    callEventIfPopconfirmShouldNotShow() {
      if (!this.shouldShow) {
        this.$emit(this.defaultEvent);
      }
    },
  },
};
